module.exports = __webpack_public_path__ + "img/Flag_of_Malaysia.15cd3677.svg";